import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'; declare var $: any;
import { Subject, combineLatest } from 'rxjs';
import { AnnuityItemsViewModel } from '../../../../models/annuity-view.model';
import { DickerSelectListItem } from '../../../../models/csp.model';
import { CommonService } from '../../../../services';
import { CspAzureLocationModel } from '../../../../models/subscription-details-view.model';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { CurrencyPipe, DatePipe } from '@angular/common';

import { DialogService } from '../../../../services/dialog.service';
import { AdobeService } from '../../../../services/adobe.service';
import { AMPubscriptionModel, GetAMPSubscription, IAdobeCustomer, IAMPAnnuityItemsViewModel, IAMPCustomerDetailsViewModel, IAMPModifySubscriptionResponse } from '../../../../models/amp.model';
import { SimpleMsgPopupComponent } from '../../../../popup-collection/simple-msg/simple-msg-popup.component';

@Component({
  selector: 'app-add-amp-product-v2',
  templateUrl: './add-amp-product-v2.component.html',
  styleUrls: ['./add-amp-product-v2.component.css'],
  providers: [CurrencyPipe]
})

export class AddAMPProductsV2Component implements OnInit, OnDestroy {

  public title = 'Add AMP Products';
  public productCategory: string;
  public AMPItemList: DickerSelectListItem[];
  public isLoadingContent: boolean = false;
  public isLoadingListView = false;
  public loadingPreview = false;
  public AMPsubsItemsPendingList: IAMPAnnuityItemsViewModel[] = [];
  public categoryList: string[] = [];
  public familyList: string[] = [];
  public familyListFiltered: string[] = [];
  public selectedCategory: string;
  public selectedFamily: string;
  public famliySearchField: string;
  public loadingFamilyList = true;
  private existingCustomerSubscriptions: GetAMPSubscription[] = [];
  private customer: IAdobeCustomer


  hideAddButton = false;
  tenantId: string;
  productType: string;
  setFullWindow = false;
  showSideBar = false;
  sideBarSoftwareSearch = "";
  sideBarSubscriptionSearch = "";
  sideBarAzureRiSearch = "";
 

  defaultMpn: string;
  annuityItems: AnnuityItemsViewModel[] = [];

  //Online Service
  searchSubscriotion: string;
  selectedSubscriptionType: string;
  subscriptionItems: AnnuityItemsViewModel[] = [];
  subscriptionItemsFilter: AnnuityItemsViewModel[] = [];
  stockeCodeArray: string[] = [];

  locationList: CspAzureLocationModel[];
  selectedLocation: string;

  checkMpnId: boolean = true;
  isCheck: Boolean;

  //ngunsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private adobeService: AdobeService,
    private commonService: CommonService,
    private dialogService: DialogService,
    private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe,
    private dialog: MatDialog
  ) { }

  async ngAfterViewInit(): Promise<void> {
    await this.commonService.waitForElm('#levelOne');
    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      setTimeout(() => {
        if (!$('#confirmAMPProduct').length) {
          // console.log('add-amp-product scroll')
          $('#levelOne').animate({ scrollLeft: $('#manageamp').width() + 505 }, 400);
        }
      }, 100);
    });
  }

  ngOnInit() {
    this.isLoadingListView = true;

    combineLatest([
      this.activatedRoute.paramMap,
      this.activatedRoute.parent.paramMap,
      this.adobeService.currentAMPCustomerDetailsWatch,
      this.adobeService.getCurrentAMPSubscriptions
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([p1, p2, response, subs]) => {

        this.customer = response?.customer;

        this.existingCustomerSubscriptions = subs;

        if (p1.get('category')?.includes("ENTERPRISE")) this.productCategory = 'ENTERPRISE';
        if (p1.get('category')?.includes("TEAMS")) this.productCategory = 'TEAMS';

        this.tenantId = p2.get('tenantId');

        if (response &&  this.tenantId && this.productCategory) {
          this.isLoadingContent = true;
          const segment = response?.customer?.market_segment;
          this.adobeService.getAMPItemCategories(segment).pipe(takeUntil(this.ngUnsubscribe)).subscribe(res => {
            
            this.AMPItemList = [...res]
            this.selectedSubscriptionType = this.AMPItemList[0]?.value;

            const effectiveDate = this.customer?.three_year_commitment_status.toLocaleLowerCase() == 'committed' ? this.datePipe.transform(this.customer?.three_year_commitment_start_date, 'dd-MM-yyyy') : null;

            this.adobeService.getAMPitems(this.tenantId, this.selectedSubscriptionType, effectiveDate)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe((list: AnnuityItemsViewModel[]) => {
                this.isLoadingListView = false;

                // decide list will be 3yc or annual
                // const is3YC = response?.customer?.is_3y_commit;
                // this.subscriptionItems = is3YC ?
                //   [ ...list ].filter(item => item.description.toLocaleLowerCase().includes('3yc')) :
                //   [ ...list ].filter(item => !item.description.toLocaleLowerCase().includes('3yc'));

                this.subscriptionItems = p1.get('category')?.includes("USAGE") ? [ ...list ].filter(i => i.chargeType == 'USAGE') : [ ...list ]

                for (let i = 0; i < this.subscriptionItems.length; i++) {
                  this.subscriptionItems[i].effectiveDate = effectiveDate;
                }

                // hide family that contains no products (same family and productType group)
                this.familyList = [ ...new Set([ ...this.subscriptionItems ].map(item => item.tertiary_Category)) ].sort();
                this.familyListFiltered = [ ...this.familyList ].filter(family => {
                  const products = this.subscriptionItems
                    .filter(annuityItem => annuityItem.secondary_Category == this.productCategory)
                    .filter(annuityItem => annuityItem.tertiary_Category == family);
                  return products?.length > 0
                });
                
                // select first family on default
                this.selectedFamily = this.familyListFiltered?.[0];
                this.changeFamily(this.selectedFamily);

                this.loadingFamilyList = false;
                this.isLoadingContent = false;
              });
          });
        } 
    })
  }

  public changeCategory(event: string): void {
    this.subscriptionItemsFilter = this.subscriptionItems
      .filter(annuityItem => annuityItem.tertiary_Category == this.selectedFamily)
      .filter(annuityItem => annuityItem.secondary_Category == event);
  }

  public changeFamily(family: string): void {
    this.subscriptionItemsFilter = this.subscriptionItems
      .filter(annuityItem => annuityItem.secondary_Category == this.productCategory)
      .filter(annuityItem => annuityItem.tertiary_Category == family);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.isLoadingContent = !currentLoadingStatus;
  }

  public filterSubscriptionItems(): void {        
    this.subscriptionItemsFilter = this.subscriptionItems
      .filter(annuityItem => annuityItem.secondary_Category == this.productCategory)
      .filter(annuityItem => annuityItem.tertiary_Category == this.selectedFamily)
      .filter(annuityItem => annuityItem.description.toLowerCase().includes(this.searchSubscriotion.toLowerCase()) || annuityItem.stockCode.toLowerCase().includes(this.searchSubscriotion.toLowerCase()));    
  }

  /**
   * If min/max qty fields has value then it should validate,
   * if it's empty or 0 then it should not validate.
   */
  public changeQty(annuityItem: AnnuityItemsViewModel): void {
    const min = this.commonService.toInteger(annuityItem?.minQty?.replace(',', ''));
    const max = this.commonService.toInteger(annuityItem?.maxQty?.replace(',', ''));

    if (min !== 0 ) {
      if (this.commonService.toInteger(annuityItem.quantity) < min) {
        this.commonService.implementToast(`the min qty is ${ min.toString() }`, "Info");
        annuityItem.quantity = min.toString();
      }
    }
    if (max !== 0) {
      if (this.commonService.toInteger(annuityItem.quantity) > max) {
        this.commonService.implementToast(`the max qty is ${ max.toString() }`, "Info");
        annuityItem.quantity = max.toString();
      }
    }
  }

  public addSubscriptionItem(annuityItem: AnnuityItemsViewModel): void {
    annuityItem.totalPrice = this.commonService.toNumber(annuityItem.itemPrice.replace('$', '').replace(',', '')) * this.commonService.toNumber(annuityItem.quantity);
    this.AMPsubsItemsPendingList.push(new AnnuityItemsViewModel(annuityItem));

    // this.commonService.implementToast("Item added successfully", "Success");
    //navigate to product confirm screen
    this.continueComfirmProduct();
    this.showSideBarByType();
  }

  public removeSubscriptionPendingItem(index: number): void {
    this.AMPsubsItemsPendingList.splice(index, 1);
    this.continueComfirmProduct();
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  showSideBarByType() {
    if (!this.showSideBar) {
      this.showSideBar = true;
    }
  }

  close() {
    if (this.AMPsubsItemsPendingList?.length) {
      this.dialogService.confirm("Leave Site? Changes that you made may not be saved.")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((canLeave: boolean) => {
          if (canLeave) {
            this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/AMP/AMPDetails/" + this.tenantId);
            $('#levelOne').animate({ scrollLeft: 250 }, 400);
          }
        });

    } else {
      this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/AMP/AMPDetails/" + this.tenantId);
      $('#levelOne').animate({ scrollLeft: 250 }, 400);
    }
  }


  confirmProduct() {
    if (this.customer?.three_year_commitment_status == 'REQUESTED') {
      this.dialog.open(SimpleMsgPopupComponent, {
        width: '600px',
        data: {
          title: 'Warning',
          msg: 'This customer has been invited to take advantage of the 3YC volume discount program however has not accepted the invitation.  Any purchases made prior to accepting the invitation will be charged at standard pricing.',
          msg2: 'Would you like to continue?',
          buttonName: 'Continue',
          showCancel: true
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.router.navigate(['ConfirmAMPProducts'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
        }
      });
    } else {
      this.router.navigate(['ConfirmAMPProducts'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
    }
  }

  public quantityChange() {
    this.continueComfirmProduct();
  }

  private continueComfirmProduct() {
    const confirmSubscriptions = [] as AMPubscriptionModel[];

    this.AMPsubsItemsPendingList.forEach(annuityItem => {

      const previewItem = {
        tenantId: this.tenantId,
        mpnId: this.commonService.parseNPM(annuityItem.mpn),
        subscriptionId: '',
        subscriptionDescription: annuityItem.subscriptionDescription,
        stockDescription: annuityItem.description,
        parentSubscriptionId: '',
        stockCode: annuityItem.stockCode,
        qty: annuityItem?.quantity?.toString(),
        status: '',
        ownerEmail: annuityItem.ownerEmail,
        price: annuityItem.itemPrice,
        totalPrice: annuityItem.totalPrice.toString(),
        billingFrequency: annuityItem.billingFrequency,
        stockGroup: annuityItem.stockGroup,
        offerId: annuityItem.offerId,
        chargeType: annuityItem.chargeType,
        orderType: 'PREVIEW',
        inEffectivePriceDate: annuityItem.effectiveDate,
      } as AMPubscriptionModel;
      
      if (previewItem.tenantId) {
        confirmSubscriptions.push(previewItem);
      }
    });

    this.loadingPreview = true
    this.adobeService.createOrCancelAMPSubscription(confirmSubscriptions)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: IAMPModifySubscriptionResponse[]) => {
          if (res.length) {
            let navigate = true;
            const allExistingSKU = [ ...this.existingCustomerSubscriptions ]?.map(x=> x.out_stock_code);
            
            this.AMPsubsItemsPendingList = [ ...this.AMPsubsItemsPendingList ].map((item, index) => {
  
              item.isExisting = allExistingSKU.includes(item.stockCode);
              item.previewPrice = this.currencyPipe.transform(res[index].unitPrice,'AUD', 'symbol-narrow','.2-2');
              item.previewRRP = this.currencyPipe.transform(res[index].rrp, 'AUD', 'symbol-narrow','.2-2');
              item.previewStockCode = res[index].stockDescription;
              item.preivewDescription = res[index].subscriptionDescription;
              item.message = res[index].message;
            
  
              if (res[index].message != 'Successful') {
                navigate = false;
                this.commonService.implementToast((res[index].message), "Error");
              }
  
              return item
            });

            const filteredList = this.AMPsubsItemsPendingList.filter(item => item.message !== 'Product not found');
            if (filteredList.length !== this.AMPsubsItemsPendingList.length) {
              this.commonService.implementToast("Product not found", "Error");
              this.AMPsubsItemsPendingList = filteredList;
            }

            this.adobeService.monitorAMPPendingSubscriptions(this.AMPsubsItemsPendingList);
  
            if (navigate) {
              // this.router.navigate(['ConfirmAMPProducts'], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute });
            } else {
              this.AMPsubsItemsPendingList = [];
            }
          }
          
        },
        error: (error: string) => this.commonService.implementToast(error, "Error"),
        complete: () => this.loadingPreview = false
      });
  }

  public onFamilySearchChange() {
    this.familyListFiltered = this.familyList.filter(x => x.toLowerCase().includes(this.famliySearchField.toLowerCase())).filter(family => {
      const products = this.subscriptionItems
        .filter(annuityItem => annuityItem.secondary_Category == this.productCategory)
        .filter(annuityItem => annuityItem.tertiary_Category == family);
      return products?.length > 0
    });;
  }

  public isActive(family: string): boolean {
    return this.selectedFamily == family;
  }

  public selectFamily(family: string): void {
    this.selectedFamily = family;
    this.changeFamily(family);
  }

  
  closeSideBar() {
    if (this.AMPsubsItemsPendingList?.length) {
      this.dialogService.confirm("Empty Cart? Changes that you made may not be saved.")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((canLeave: boolean) => {
          if (canLeave) {
            this.AMPsubsItemsPendingList = [];
            this.showSideBar = false;
          }
        });
    } else {
      this.showSideBar = false;
    }
  }
  
  closeFamilyPanel() {
    if (this.AMPsubsItemsPendingList?.length) {
      this.dialogService.confirm("Leave Site? Changes that you made may not be saved.")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((canLeave: boolean) => {
          if (canLeave) {
            this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/AMP/AMPDetails/" + this.tenantId);
            $('#levelOne').animate({ scrollLeft: 250 }, 400);
          }
        });

    } else {
      this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/AMP/AMPDetails/" + this.tenantId);
      $('#levelOne').animate({ scrollLeft: 250 }, 400);
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
